import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Progettiamo",
    text: "Ogni lavoro parte da un'idea studiata su misura: il nostro studio grafico traduce gli obiettivi del tuo brand in concept visivi concreti, pronti per la produzione.",
  },
  {
    n: "02",
    title: "Produciamo",
    text: "Stampa di grande e piccolo formato, taglio, finitura: controlliamo direttamente ogni fase produttiva per garantire colori fedeli, materiali giusti e tempi rispettati.",
  },
  {
    n: "03",
    title: "Installiamo",
    text: "Mani in pasta fino alla fine. I nostri team montano stand, insegne, vetrofanie e wrapping direttamente sul campo, in fiera come in negozio, in tutta Italia.",
  },
];

export const About = () => (
  <section id="chi-siamo" className="relative py-24 lg:py-32" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="text-xs tracking-[0.35em] uppercase text-zinc-500 mb-6"
          >
            Chi Siamo
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display font-semibold tracking-tight text-4xl sm:text-5xl leading-[1.08] text-zinc-900"
            style={{ wordSpacing: "0.12em" }}
            data-testid="about-title"
          >
            Il tuo partner visivo,<br />
            <span className="text-gradient">dalla bozza al montaggio.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-6 text-zinc-600 leading-relaxed text-base"
            data-testid="about-copy"
          >
            I&amp;G Grafiche è il partner che le aziende scelgono quando la visibilità non ammette errori.
            Competenza tecnica, presenza sul campo e un unico interlocutore per stampa, allestimenti e
            comunicazione visiva a 360°: tu pensi al business, noi pensiamo a farti notare.
          </motion.p>
        </div>
      </div>

      <div className="lg:col-span-7 flex flex-col gap-14">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="group flex gap-6 sm:gap-10 items-start border-b border-zinc-200 pb-14"
            data-testid={`about-chapter-${c.n}`}
          >
            <span className="font-display font-bold text-6xl sm:text-8xl leading-none text-gradient shrink-0 select-none">
              {c.n}
            </span>
            <div className="pt-2 sm:pt-4">
              <h3 className="font-display font-medium text-2xl sm:text-3xl tracking-tight text-zinc-900 group-hover:text-[#FF007F] transition-colors duration-300">
                {c.title}
              </h3>
              <p className="mt-3 text-zinc-600 leading-relaxed text-sm sm:text-base max-w-md">{c.text}</p>
            </div>
          </motion.div>
        ))}
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="relative rounded-2xl overflow-hidden border border-zinc-200"
        >
          <img
            src="/images/officina.jpg"
            alt="Il laboratorio I&G Grafiche: team al lavoro su insegna, furgone e ledwall"
            className="w-full h-72 sm:h-96 object-cover hover:scale-105 transition-transform duration-700"
            data-testid="about-image"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />
          <p className="absolute bottom-5 left-6 text-xs tracking-[0.25em] uppercase text-white/90">
            Quello che facciamo, ogni giorno.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
